import React, { useState, useEffect } from "react";
import dayjs from 'dayjs'
import {
    Grid, TextField, FormHelperText, Typography, Box, Autocomplete, Chip, Button, useMediaQuery,
    Select, MenuItem, Checkbox, Stack, ToggleButtonGroup, ToggleButton
} from "@mui/material";
import SendIcon from '@mui/icons-material/Send';
import { useTheme } from '@mui/material/styles';
import { useLocation } from "react-router-dom";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

import RemoveIcon from "@mui/icons-material/RemoveCircleOutlineSharp";

import * as CONSTANTS from "../../constants"

import { 
    view_wazaren_namelist,
    view_wotageishi_namelist,
    view_organization_namelist,
    import_wotageishi_data,
} from "../../services/topic_view";


const FillInForm = ({ formik, lang }) => {

    useEffect(() => { window.scrollTo(0, 0) }, []);

    const location = useLocation();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    const [countryList, setCountryList] = useState(CONSTANTS.COUNTRY_LIST);

    const [targetWotageishi, setTargetWotageishi] = useState(null)
    const [orgWazarens, setOrgWazarens] = useState([]);
    const [wazarens, setWazarens] = useState([]);
    const [wotageishis, setWotageishis] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [selectedOrganizations, setSelectedOrganizations] = useState([]);
    const [countries, setCountries] = useState([]);

    const [marking, setMarking] = useState('');
    const [markings, setMarkings] = useState(formik.values.markings);
    
    const [currentWotageishi, setCurrentWotageishi] = useState(null);

    const updateOrgWazarens = (wazarens) => {
        setOrgWazarens(wazarens);
        let original_wazaren_uids = [];
        let original_wazaren_names = [];
        wazarens.forEach(wazaren => {
            original_wazaren_uids.push(wazaren.uid);
            original_wazaren_names.push(wazaren.name)
        })
        formik.values.original_wazaren_uids = original_wazaren_uids;
        formik.values.original_wazaren_names = original_wazaren_names;
    }

    const updateSelectedOrganizations = (organizations) => {
        setSelectedOrganizations(organizations);
        let organization_uids = [];
        let organization_names = [];
        organizations.forEach(organization => {
            organization_uids.push(organization.uid);
            organization_names.push(organization.name)
        })
        formik.values.organization_uids = organization_uids;
        formik.values.organization_names = organization_names;
    }

    function filterCountries(countries, letter) {
        letter = letter.toLowerCase();
        var filteredCountries = countries.filter(function(country) {
           return country.label[lang].toLowerCase().startsWith(letter);
        });
        return filteredCountries;
    }

    const updateWotageishiUid = (wotageishi) => {
        setTargetWotageishi(wotageishi);
        if (wotageishi === null) {
            formik.values.wotageishi_uid = 0;
        } else {
            formik.values.wotageishi_uid = wotageishi.uid;
        }
    }

    const updateCountries = (countries) => {
        setCountries(countries);
        let active_regions = []
        countries.forEach(country => {
            active_regions.push(country.code)
        })
        formik.values.active_regions = active_regions;
    }
    const updateMarkings = (markings) => {
        setMarkings(markings);
        formik.values.markings = markings;
        setMarking('');
    }

    const updateWazarenTextField = (newValue) => {
        fetchWazarens(newValue);
    }
    const updateWotageishiTextField = (newValue) => {
        fetchWotageishis(newValue);
    }
    const updateOrganizationTextField = (newValue) => {
        fetchOrganizations(newValue);
    }

    const fetchWazarens = async (name) => {
            const [status, result] = await view_wazaren_namelist(lang, name)
            if (status === 200) {
                setWazarens(result.wazarens);
            }
        };
    
    const fetchOrganizations = async (name) => {
        const [status, result] = await view_organization_namelist(lang, name)
        if (status === 200) {
            setOrganizations(result.organizations);
        }
    };

    const fetchWotageishis = async (name) => {
        const [status, result] = await view_wotageishi_namelist(lang, name)
        if (status === 200) {
            setWotageishis(result.wotageishis);
        }
    };

    const fetchWotageishiDataByUid = async (uid) => {
        const [status, result] = await import_wotageishi_data(lang, uid)
        if (status === 200) {
            setCurrentWotageishi(result);
            autoFillFormik(result);
        }
    }

    // send api request for url changes
    useEffect(() => {
        fetchWazarens('');
        fetchWotageishis('');
        fetchOrganizations('');
    }, [location.pathname]);


    const UpdateDefaultName = (option) => {
        switch (option) {
            case 'en':
                formik.values.default_name = formik.values.name_en;
                break;
            case 'jp':
                formik.values.default_name = formik.values.name_jp;
                break;
            case 'tc':
                formik.values.default_name = formik.values.name_tc;
                break;
            case 'sc':
                formik.values.default_name = formik.values.name_sc;
                break;
        }
    }

    const autoFillFormik = (currentWotageishi) => {
        if (currentWotageishi === null) return
        
        // Update formik values one by one
        formik.values.name_en = currentWotageishi.name.en;
        formik.values.name_jp = currentWotageishi.name.jp;
        formik.values.name_tc = currentWotageishi.name.tc;
        formik.values.name_sc = currentWotageishi.name.sc;
        formik.values.default_name = currentWotageishi.default_name;
        formik.values.active_regions = currentWotageishi.active_regions;
        formik.values.markings = currentWotageishi.markings;
        formik.values.official_account_youtube = currentWotageishi.official_account.youtube;
        formik.values.official_account_bilibili = currentWotageishi.official_account.bilibili;
        formik.values.official_account_x = currentWotageishi.official_account.x;
        formik.values.organization_uids = currentWotageishi.organization_uids;
        formik.values.organization_names = currentWotageishi.organization_names;
        formik.values.original_wazaren_uids = currentWotageishi.original_wazaren_uids;
        formik.values.original_wazaren_names = currentWotageishi.original_wazaren_names;
        formik.values.start_date = dayjs(currentWotageishi.start_date.value);
        formik.values.has_year = currentWotageishi.start_date.has_year;
        formik.values.has_month = currentWotageishi.start_date.has_month;
        formik.values.has_day = currentWotageishi.start_date.has_day;
        setMarkings(currentWotageishi.markings);
    }

    const insertOrgWazarens = (original_wazaren_uids, original_wazaren_names) => {
        const orgWazarens_v = original_wazaren_uids.map((original_wazaren_uid, index) => ({
            uid: original_wazaren_uid,
            name: original_wazaren_names[index]
        }));
        setOrgWazarens(orgWazarens_v);
    };

    const insertCountries = (active_regions) => {
        const countries_v = active_regions.map((countryCode, index) => (countryList.find(o => o.code===countryCode)));
        setCountries(countries_v);
    };

    const insertOrganizations = (organization_uids, organization_names) => {
        const organizations_v = organization_uids.map((organization_uid, index) => ({
            uid: organization_uid,
            name: organization_names[index]
        }));
        setSelectedOrganizations(organizations_v);
    }

    const radioButtonMap = {
        'en': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.EN[lang], 
        'jp': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.JP[lang], 
        'tc': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.TC[lang],
        'sc': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.SC[lang], 
    };

    useEffect(()=>{
        insertOrgWazarens(
            formik.values.original_wazaren_uids,
            formik.values.original_wazaren_names,
        )
    }, [formik.values.organization_names])

    useEffect(()=>{
        insertCountries(
            formik.values.active_regions
        )
    }, [formik.values.active_regions])

    useEffect(()=>{
        insertOrganizations(
            formik.values.organization_uids,
            formik.values.organization_names
        )
    }, [formik.values.organization_names])
    

    return (
        <Grid
            container
            spacing={2}
        >
            <Grid
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                   {CONSTANTS.REQUEST_TOPIC.FIELDS.WOTAGEISHI_UID[lang].toUpperCase()}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.WOTAGEISHI_UID[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Autocomplete
                    id="wazarens-standard"
                    freeSolo
                    filterSelectedOptions
                    options={wotageishis}
                    onChange={(e, wotageishi) =>updateWotageishiUid(wotageishi)}
                    getOptionLabel={wotageishi => wotageishi.name}
                    renderTags={() => {}}
                    value={targetWotageishi}
                    componentsProps={{
                        paper: {
                            sx: {
                                width: '100%'
                            }
                        }
                    }}
                    renderInput={params => (
                    <TextField
                        {...params}
                        variant="standard"
                        placeholder=""
                        margin="normal"
                        fullWidth
                        onChange={(e) => {
                            updateWotageishiTextField(e.target.value);
                        }}
                    />
                    )}
                />
            </Grid>
            { isMobile? <Grid item xs={4} /> : <></> }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Box
                    name="Creator Result"
                    variant="outlined"
                    type="text"
                    fullWidth
                    sx={{p: 1, border: '1px solid grey', borderRadius: '5px' }}
                    
                >
                    <Typography
                        textAlign="center"
                    >
                        {targetWotageishi? targetWotageishi.uid: '---'}
                    </Typography>
                </Box>
            </Grid>
            <Grid
                item
                xs={12}
                textAlign={'center'}
                justifyContent={'center'}
            >
                <Button
                    variant="outlined"
                    disabled={formik.values.wotageishi_uid===0}
                    onClick={()=> {
                        fetchWotageishiDataByUid(formik.values.wotageishi_uid)
                    }}
                    sx={{
                        width: '50%'
                    }}
                >
                    {CONSTANTS.REQUEST_TOPIC.BUTTONS.LOAD_WOTAGEISHI_DATA[lang]}
                </Button>
            </Grid>
            <Grid
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.NAME[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.EN[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <TextField
                    name="English Name"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.NAME.EN[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.name_en && formik.errors.name_en)}
                    helperText={formik.errors.name_en && formik.errors.name_en}
                    onChange={(e) => {
                        formik.handleChange("name_en")(e);
                        if (formik.values.default_language === 'en') {
                            formik.handleChange("default_name")(e);
                        }
                    }}
                    value={formik.values.name_en}
                />
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.JP[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <TextField
                    name="Japanese Name"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.NAME.JP[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.name_jp && formik.errors.name_jp)}
                    helperText={formik.errors.name_jp && formik.errors.name_jp}
                    onChange={(e) => {
                        formik.handleChange("name_jp")(e);
                        if (formik.values.default_language === 'jp') {
                            formik.handleChange("default_name")(e);
                        }
                    }}
                    value={formik.values.name_jp}
                />
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.TC[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <TextField
                    name="Traditional Chinese Name"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.NAME.TC[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.name_tc && formik.errors.name_tc)}
                    helperText={formik.errors.name_tc && formik.errors.name_tc}
                    onChange={(e) => {
                        formik.handleChange("name_tc")(e);
                        if (formik.values.default_language === 'tc') {
                            formik.handleChange("default_name")(e);
                        }
                    }}
                    value={formik.values.name_tc}
                />
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.SC[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <TextField
                    name="Simplified Chinese Name"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.NAME.SC[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.name_sc && formik.errors.name_sc)}
                    helperText={formik.errors.name_sc && formik.errors.name_sc}
                    onChange={(e) => {
                        formik.handleChange("name_sc")(e);
                        if (formik.values.default_language === 'sc') {
                            formik.handleChange("default_name")(e);
                        }
                    }}
                    value={formik.values.name_sc}
                />
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.DEFAULT_LANG[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }} >
                    {
                        isMobile?
                        <Select
                            defaultValue="jp"
                            value={formik.values.default_language}
                            onChange={(event) => {
                                UpdateDefaultName(event.target.value);
                                formik.setFieldValue('default_language', event.target.value);
                            }}
                            sx={{width: "100%"}}
                        >
                            {Object.keys(radioButtonMap).map((key, index) => (
                                <MenuItem
                                    value={key}
                                >
                                    {radioButtonMap[key]}
                                </MenuItem>
                            ))}
                        </Select>
                        :
                        <ToggleButtonGroup
                            orientation="horizontal"
                            color="primary"
                            value={formik.values.default_language}
                            onChange={(event) => {
                                UpdateDefaultName(event.target.value);
                                formik.setFieldValue('default_language', event.target.value);
                            }}
                            exclusive
                            sx={{
                                minHeight: 48,
                                padding: '4px',
                                borderRadius: '12px',
                                width: "100%",
                            }}
                        >
                            {Object.keys(radioButtonMap).map((key, index) => (
                                <ToggleButton
                                    key={key}
                                    value={key}
                                    disableIcon
                                    variant="plain"
                                    sx={{ px: 2, alignItems: 'center', width: '25%', p: 1.5, textAlign: 'center'}}
                                >{radioButtonMap[key]}</ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    }
                </Box>
            </Grid>
            <Grid
                mt={3}
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.OTHER[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.START_DATE[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >   
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker 
                        format="DD/MM/YYYY"
                        onChange={(e) => {
                            formik.values.start_date = e
                        }}
                        value={formik.values.start_date}
                        sx={{width: '100%'}}
                    />
                </LocalizationProvider>
            </Grid>
            { isMobile? <Grid item xs={4} />: <></> }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >   
                <Stack 
                    direction={"row"} 
                    width={'100%'} 
                    margin={'auto'} 
                    flex={1} 
                    justifyContent="space-evenly"
                >
                    <Stack alignItems="center">
                        <Typography variant="body2">{CONSTANTS.REQUEST_TOPIC.FIELDS.YEAR[lang]}</Typography>
                        <Checkbox 
                            checked={formik.values.has_year}
                            onChange={formik.handleChange('has_year')}
                        />
                    </Stack>
                    <Stack alignItems="center">
                        <Typography variant="body2">{CONSTANTS.REQUEST_TOPIC.FIELDS.MONTH[lang]}</Typography>
                        <Checkbox 
                            checked={formik.values.has_month}
                            onChange={formik.handleChange('has_month')}
                        />
                    </Stack>
                    <Stack alignItems="center">
                        <Typography variant="body2">{CONSTANTS.REQUEST_TOPIC.FIELDS.DAY[lang]}</Typography>
                        <Checkbox 
                            checked={formik.values.has_day}
                            onChange={formik.handleChange('has_day')}
                        />
                    </Stack>
                </Stack>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WOTAGEISHI_DETAILS.FAMOUS_WAZAREN[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Autocomplete
                    multiple
                    id="wazarens-standard"
                    freeSolo
                    filterSelectedOptions
                    options={wazarens}
                    onChange={(e, wazaren) =>updateOrgWazarens(wazaren)}
                    getOptionLabel={wazaren => wazaren.name}
                    renderTags={() => {}}
                    value={orgWazarens}
                    componentsProps={{
                        paper: {
                            sx: {
                                width: '100%'
                            }
                        }
                    }}
                    renderInput={params => (
                    <TextField
                        {...params}
                        variant="standard"
                        placeholder=""
                        margin="normal"
                        fullWidth
                        onChange={(e) => {
                            updateWazarenTextField(e.target.value);
                        }}
                    />
                    )}
                />
            </Grid>
            {
                isMobile?
                <Grid
                    item
                    xs={4}
                    alignContent={'center'}
                >

                </Grid>
                :
                <>
                </>
            }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {
                        orgWazarens.map((option, index) => {
                            // This is to handle new options added by the user (allowed by freeSolo prop).
                            const label = option.name || option;
                            return (
                                <Chip 
                                    size="medium"
                                    variant="outlined"
                                    key={option}
                                    label={label}
                                    deleteIcon={<RemoveIcon />} 
                                    onDelete={() => {
                                        updateOrgWazarens(orgWazarens.filter(entry => entry !== option));
                                    }}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                    }}
                                />
                            );
                        })
                    }
                </Stack>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WOTAGEISHI_DETAILS.ORGANIZATION[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Autocomplete
                    multiple
                    id="organizations-standard"
                    freeSolo
                    filterSelectedOptions
                    options={organizations}
                    onChange={(e, organization) => updateSelectedOrganizations(organization)}
                    getOptionLabel={organization => organization.name}
                    renderTags={() => {}}
                    value={selectedOrganizations}
                    componentsProps={{
                        paper: {
                            sx: {
                                width: '100%'
                            }
                        }
                    }}
                    renderInput={params => (
                    <TextField
                        {...params}
                        variant="standard"
                        placeholder=""
                        margin="normal"
                        fullWidth
                        onChange={(e) => {
                            updateOrganizationTextField(e.target.value);
                        }}
                    />
                    )}
                />
            </Grid>
            {
                isMobile?
                <Grid
                    item
                    xs={4}
                    alignContent={'center'}
                >

                </Grid>
                :
                <>
                </>
            }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {
                        selectedOrganizations.map((option, index) => {
                            // This is to handle new options added by the user (allowed by freeSolo prop).
                            const label = option.name || option;
                            return (
                                <Chip 
                                    size="medium"
                                    variant="outlined"
                                    key={option}
                                    label={label}
                                    deleteIcon={<RemoveIcon />} 
                                    onDelete={() => {
                                        updateSelectedOrganizations(selectedOrganizations.filter(entry => entry !== option));
                                    }}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                    }}
                                />
                            );
                        })
                    }
                </Stack>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WOTAGEISHI_FILTER.COUNTRY[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >   
                <Autocomplete
                    multiple
                    id="organizations-standard"
                    freeSolo
                    filterSelectedOptions
                    options={countryList}
                    onChange={(e, newValue) => {updateCountries(newValue)}}
                    getOptionLabel={country => country.label[lang]}
                    renderTags={() => {}}
                    value={countries}
                    componentsProps={{
                        paper: {
                            sx: {
                                width: '100%'
                            }
                        }
                    }}
                    renderInput={params => (
                        <TextField
                            {...params}
                            variant="standard"
                            placeholder=""
                            margin="normal"
                            fullWidth
                            onChange={(e, newValue) => {setCountryList(filterCountries(CONSTANTS.COUNTRY_LIST, e.target.value))}}
                        />
                    )}
                />
            </Grid>
            {
                isMobile?
                <Grid
                    item
                    xs={4}
                    alignContent={'center'}
                >

                </Grid>
                :
                <>
                </>
            }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >   
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {
                        countries.map((option, index) => {
                            // This is to handle new options added by the user (allowed by freeSolo prop).
                            const label = option.label[lang] || option;
                            return (
                                <Chip 
                                    size="medium"
                                    variant="outlined"
                                    key={option.code}
                                    label={label}
                                    deleteIcon={<RemoveIcon />} 
                                    onDelete={() => {
                                        updateCountries(countries.filter(entry => entry !== option));
                                    }}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                    }}
                                />
                            );
                        })
                    }
                </Stack>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WOTAGEISHI_DETAILS.MARKINGS[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >   
                <TextField
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.MARKINGS[lang]}
                    value={marking}
                    onChange={(e) => {
                        setMarking(e.target.value);
                    }}
                    sx={{
                        width: '100%'
                    }}
                    InputProps={{
                        endAdornment: 
                        <Button 
                            variant="contained"
                            onClick={() => {
                                if (marking !== '') updateMarkings([...markings, marking]);
                            }}
                            sx={{
                                height: '100%'
                            }}
                        >
                            <SendIcon />
                        </Button>
                    }}
                /> 
            </Grid>
            {
                isMobile?
                <Grid
                    item
                    xs={4}
                    alignContent={'center'}
                >

                </Grid>
                :
                <>
                </>
            }
            <Grid
                item
                xs={8}
                sm={4}
                alignContent={'center'}
            >   
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {
                        markings.map((option, index) => {
                            // This is to handle new options added by the user (allowed by freeSolo prop).
                            const label = option || option;
                            return (
                                <Chip 
                                    size="medium"
                                    variant="outlined"
                                    key={option}
                                    label={label}
                                    deleteIcon={<RemoveIcon />} 
                                    onDelete={() => {
                                        updateMarkings(markings.filter(entry => entry !== option));
                                    }}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                    }}
                                />
                            );
                        })
                    }
                </Stack>
            </Grid>
            <Grid
                mt={3}
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.WOTAGEISHI_DETAILS.SOCIAL_MEDIA[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    YouTube
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                
                <TextField
                    name="YouTube"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.VIDEO_LINK.YOUTUBE[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.official_account_youtube && formik.errors.official_account_youtube)}
                    onChange={formik.handleChange('official_account_youtube')}
                    value={formik.values.official_account_youtube}
                />
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    Bilibili
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                
                <TextField
                    name="Bilibili"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.VIDEO_LINK.BILIBILI[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.official_account_bilibili && formik.errors.official_account_bilibili)}
                    onChange={formik.handleChange('official_account_bilibili')}
                    value={formik.values.official_account_bilibili}
                />
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    X
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                
                <TextField
                    name="X"
                    variant="outlined"
                    placeholder={CONSTANTS.REQUEST_TOPIC.PLACEHOLDERS.ENTER.VIDEO_LINK.X[lang]}
                    type="text"
                    fullWidth
                    size="small"
                    error={Boolean(formik.touched.official_account_x && formik.errors.official_account_x)}
                    onChange={formik.handleChange('official_account_x')}
                    value={formik.values.official_account_x}
                />
            </Grid>
            
            {formik.errors.submit && (
                <Grid
                    item
                    xs={12}
                >
                <FormHelperText error>
                    {formik.errors.submit}
                </FormHelperText>
                </Grid>
            )}
        </Grid>
    )
}

export default FillInForm;